var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  const NAME = 'credits';
  var pageManager = fc.pageManager;

  var currentPage = pageManager.Page.create(NAME, '/' + NAME, '#' + NAME);

  currentPage.html = `<h1><img src="/assets/app/logo.svg" id="logo"></h1><div class="content" id="form"><p class="upper">Created by the lovely geeks of</p><div class="middle"><a href="//euedge.com/" target="_blank"><img src="/assets/app/euedge.png"></a></div><p class="lower">Thanks for giving it a go.</p><p class="lower">Take a new pic or reuse the same selfie to take another trip.</p></div><footer class=""><a href="/backgrounds" class="button" id="reusebutton"><img src="/assets/app/returnbutton.svg"></a><a href="/create" class="button" id="okbutton"><img src="/assets/app/photobutton1.png"></a></footer>`;

  currentPage.eventHandlers = [{
    event: 'click',
    target: '#okbutton',
    handler: function () {
      fc.ga('/credits_camera');
    }
  }, {
    event: 'click',
    target: '#okreusebutton',
    handler: function () {
      fc.ga('/reuse_selfie');
    }
  }];

  currentPage.run = function(){
    fc.ga('/credits');
    fc.fbq('Credits', 'CompleteRegistration');
  };
  pageManager.add(currentPage);

}(FakeCation));
